import { PdSuggestionBox } from "./pd-suggestion-box/PdSuggestionBox.js";
//#region src/pd-suggestion-box/pd-suggestion-box.ts
var tag = "pd-suggestion-box";
if (!customElements.get(tag)) customElements.define(tag, PdSuggestionBox);
//#endregion
export { PdSuggestionBox };
